/* eslint-disable */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminDashboard from '../Pages/AdminDashboard'; 
import ArticlePost from '../Components/ArticlePost';
import { Container } from '@material-ui/core';


const PrivateAdminRoute = ({ children }) => {
  const token = localStorage.getItem('access_token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  return token && user?.is_admin ? children : <Navigate to="/Home" />;
};

const AdminRoutes = () => {
  return (
    <Container>
      <Routes>
        <Route index element={
          <PrivateAdminRoute>
            <Navigate to="/dashboard" replace />
          </PrivateAdminRoute>
        } />

        <Route path="/dashboard" element={
          <PrivateAdminRoute>
            <AdminDashboard />
          </PrivateAdminRoute>
        } />
    
        <Route path="/create" element={
          <PrivateAdminRoute>
            <ArticlePost />
          </PrivateAdminRoute>
        } />

        <Route path="/edit/:id" element={
          <PrivateAdminRoute>
            <ArticlePost isEdit={true} />
          </PrivateAdminRoute>
        } />

        <Route path="*" element={
          <PrivateAdminRoute>
            <Navigate to="/dashboard" replace />
          </PrivateAdminRoute>
        } />
      </Routes>
    </Container>
  );
};

export default AdminRoutes;